<template>
  <div class="js-car-manage app-container car-management">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-form :model="listQuery" label-suffix="：" label-width="auto">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('public.licensePlate')">
                <el-input
                  v-model="listQuery.licensePlate"
                  filterable
                  clearable
                  :placeholder="$t('public.licensePlate')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('carManagement.bindingState')">
                <el-select
                  v-model="listQuery.carTerminalStatus"
                  filterable
                  clearable
                  :placeholder="$t('carManagement.bindingState')"
                >
                  <el-option
                    v-for="(item, index) in carBindStatusList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('public.obdCode')">
                <el-input
                  v-model="listQuery.barCode"
                  filterable
                  clearable
                  :placeholder="$t('public.obdCode')"
                />
              </el-form-item>
            </el-col>
            <el-col v-show="collapse" :span="6">
              <el-form-item :label="$t('carManagement.area')">
                <el-select
                  v-model="listQuery.areaId"
                  filterable
                  clearable
                  :placeholder="$t('carManagement.area')"
                >
                  <el-option
                    v-for="(item, index) in areas"
                    :key="index"
                    :label="item.areaName"
                    :value="item.areaId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-show="collapse"
            :gutter="10"
            style="margin-top: 10px; margin-bottom: 42px"
          >
            <el-col :span="6">
              <el-form-item
                class="cascader"
                :label="$t('carMonitor.monitorinfo.carStatus.model')"
              >
                <el-cascader
                  ref="cascader"
                  :placeholder="$t('carMonitor.monitorinfo.carStatus.model')"
                  v-model="listQuery.carSettings"
                  filterable
                  clearable
                  :options="models"
                  :props="props"
                  @change="handleChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('carManagement.createTime')">
                <el-row type="flex" justify="start" align="middle">
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.startTime"
                      filterable
                      clearable
                      :placeholder="$t('public.startTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                  &emsp;<span class="time-span" style="color: #ddd">——</span
                  >&emsp;
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.endTime"
                      filterable
                      clearable
                      :placeholder="$t('public.endTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('public.mobile')">
                <el-input
                  v-model="listQuery.mobile"
                  filterable
                  clearable
                  :placeholder="$t('public.mobile')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <app-search-button
        slot="bottom"
        @click-collapse="handleCollapse"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter = true"
      @click-car-bind-history="handleHistory"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-export="handleExport"
      @click-exportbi="handleExportBI"
      @click-exportso="handleExportSO"
      @click-import="handleImport"
      @click-importbi="handleImportBI"
      @click-importso="handleImportSO"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      ref="multipleTable"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @current-change="handleCurrentRowChange"
      @sort-change="sortChange"
    >
    <el-table-column
      :v-if="displayName"
      :selectable="checkboxT"
      type="selection"
      width="55">
    </el-table-column>
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{
            scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in filterTableList"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :align="item.align || 'center'"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="item.prop === 'carTerminalStatus'">
              <span :class="scope.row[item.prop] === 1 ? '' : 'errors'">{{
                scope.row[item.prop] | switchText(item.prop)
              }}</span>
            </div>
            <div v-else-if="item.prop === 'licensePlate'">
              <vue-licenseplate
                :types="0"
                :licensepalte="scope.row[item.prop]"
                :area="scope.row['areaName']"
              />
            </div>
            <div
              v-else-if="item.prop === 'modelName' || item.prop === 'brandName'"
            >
              <el-popover
                placement="top-start"
                width="230"
                trigger="hover"
                :visible-arrow="false"
                :content="
                  scope.row[item.prop] ||
                  (scope.row[item.prop] === 0 ? scope.row[item.prop] : '/')
                "
              >
                <span slot="reference">
                  {{
                    scope.row[item.prop] ||
                    (scope.row[item.prop] === 0 ? scope.row[item.prop] : "/")
                  }}</span
                >
              </el-popover>
            </div>
            <span v-else-if="item.prop === 'belong'">
              <span>{{
                $t(`carManagement.${belongList[scope.row[item.prop]]}`)
              }}</span>
            </span>
            <span
              v-else-if="item.prop === 'barCode' || item.prop === 'realName'"
              >{{ scope.row[item.prop] | switchText(item.prop) }}</span
            >
            <span v-else>{{
              scope.row[item.prop] ||
              (scope.row[item.prop] === 0 ? scope.row[item.prop] : "/")
            }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        :label="$t('public.operation')"
        :width="$t('carManagement.operate.width')"
        align="center"
      >
        <template slot-scope="scope">
          <el-row type="flex">
            <el-button
              type="primary"
              size="mini"
              :disabled="
                belongIndex !== scope.row.belong && scope.row.belong !== 0
              "
              :class="[
                scope.row['carTerminalStatus'] === 1
                  ? 'errors'
                  : 'normal_item_color',
              ]"
              @click="handleBind(scope.row)"
              >{{
                scope.row["carTerminalStatus"] == 1
                  ? $t("public.unbind")
                  : $t("public.bind")
              }}</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="handleSwitch(scope.row, 1)"
              :disabled="
                scope.row.ioStatus === 1 ||
                scope.row.io1 === null ||
                scope.row.needDisabled ||
                (belongIndex !== scope.row.belong && scope.row.belong !== 0)
              "
              :class="[
                scope.row.io1 !== 0 && scope.row.io1 !== null
                  ? 'errors'
                  : scope.row.ioStatus === 1
                  ? 'io-pending'
                  : 'normal_item_color',
              ]"
            >
              <el-row>
                <span>Switch #1</span>
              </el-row>
              <el-row>
                <span>{{
                  (scope.row.io1 === 0 || scope.row.io1 === null) &&
                  scope.row.ioStatus === 0
                    ? $t("carManagement.operate.open")
                    : scope.row.ioStatus === 1
                    ? $t("carManagement.operate.pending")
                    : $t("carManagement.operate.close")
                }}</span>
              </el-row>
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="handleSwitch(scope.row, 2)"
              :disabled="
                scope.row.ioStatus === 1 ||
                scope.row.io2 === null ||
                scope.row.needDisabled ||
                (belongIndex !== scope.row.belong && scope.row.belong !== 0)
              "
              :class="[
                scope.row.io2 !== 0 && scope.row.io2 !== null
                  ? 'errors'
                  : scope.row.ioStatus === 1
                  ? 'io-pending'
                  : 'normal_item_color',
              ]"
            >
              <el-row>
                <span>Switch #2</span>
              </el-row>
              <el-row>
                <span>{{
                  (scope.row.io2 === 0 || scope.row.io2 === null) &&
                  scope.row.ioStatus === 0
                    ? $t("carManagement.operate.open")
                    : scope.row.ioStatus === 1
                    ? $t("carManagement.operate.pending")
                    : $t("carManagement.operate.close")
                }}</span>
              </el-row>
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="(currentRow = scope.row), (lookCarDialogVisible = true)"
              >{{ $t("public.view") }}</el-button
            >
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total > 0 ? 'visible' : 'hidden', 'pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper, ->, slot"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
        <template v-slot>
          <span class="total-info">
            <span>{{ $t("carManagement.count.total") }} {{ total }}</span>
            <span
              >{{ $t("carManagement.count.binding") }} {{ totalBinding }}</span
            >
            <span
              >{{ $t("carManagement.count.unbinding") }}
              {{ totalUnbinding }}</span
            >
          </span>
        </template>
      </el-pagination>
    </div>
    <!-- 新增编辑dialog弹窗 -->
    <add-update-dialog
      :visible.sync="addUpdateVisible"
      :is-edit="isEdit"
      :data="isEdit ? currentRow : {}"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
    <!-- 查看绑定历史 -->
    <!-- <look-history-dialog :visibles.sync="lookHistoryVisible" :data="currentRow" /> -->
    <!--选择OBD设备-->
    <!-- <select-terminal-dialog
      :visibles.sync="terminalVisbles"
      @dblclick-select-terminal="selectTerminal"
    /> -->
    <!-- 查看详情 -->
    <view-vehicle-dialog
      :visible.sync="lookCarDialogVisible"
      :data="lookCarDialogVisible ? currentRow : {}"
    />

    <bind-car-dialog
      :visibles.sync="showBingCar"
      :data="currentRow"
      @success="listLoad"
    />
    <import-dialog
      :action="importConfig.url"
      :template-url="importConfig.template"
      :visibles.sync="importConfig.visible"
      @upload-success="reloadList"
    >
      <result-dialog
        :visibles.sync="importConfig.resultVisible"
        :data="importConfig.result"
        :text="importConfig.text"
        :keys="'licensePlate'"
        :message="
          $t('baseData.terminalmanage.terminalInfo.message.noImportInfo')
        "
        :is-show="importConfig.visible"
      >
      </result-dialog>
    </import-dialog>
  </div>
</template>

<script>
// 混入
import { partialForm } from "@/mixins/partialForm"
import { pagingMixin } from "@/mixins/table"
import { otherHeight } from "@/mixins/getOtherHeight"
import { tableStyle } from "@/mixins/tableStyle"
import { getPageButton } from "@/mixins/getButton"


import resolve from '@/api/resolve'
// 组件
import AddUpdateDialog from './components/addUpdateDialog'
// import lookHistoryDialog from "./components/lookHistoryDialog";
import ViewVehicleDialog from "./components/viewVehicleDialog"
import bindCarDialog from '@/views/userCenter/carManagement/components/bindCarDialog'
import importDialog from '@/components/importDialog'
import resultDialog from '@/components/resultDialog'
// 接口
import { untyOBD } from "@/api/userCenter/carManagement"
import { vehicleListUrl, deleteVehicleUrl,deleteVehicleListUrl, importVehicleUrl, exportVehicleUrl, IOLIST } from '@/api/system/company'
import { importToyotaBuyInUrl, exportToyotaBuyInUrl, importToyotaSellOutUrl, exportToyotaSellOutUrl } from '@/api/system/vehicle'
import { createCommond, getCommandParam } from '@/api/carMonitor/terminalBatch'

export default {
  name: 'vehicle',
  components: {
    AddUpdateDialog,
    ViewVehicleDialog,
    importDialog,
    resultDialog,
    bindCarDialog
  },
  filters: {
    switchText(val, type) {
      if (type === "carTerminalStatus") {
        return val === 1
          ? vm.$t("carManagement.binding")
          : vm.$t("carManagement.Unbound")
      } else if (type === "barCode" || type === "realName") {
        return val === null ? "/" : val
      }
      else {
        return ''
      }
    }
  },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      listQuery: {},
      tableHeight: 0,
      props: {
        label: "name",
        value: "id",
        children: "children",
        expandTrigger: "hover",
        // checkStrictly: true
      },
      showfilter: false,
      carBindStatusList: [
        {
          label: this.$t("carManagement.Unbound"),
          value: 0
        },
        {
          label: this.$t("carManagement.binding"),
          value: 1
        }
      ],
      tableList: [
        {
          label: this.$t("public.licensePlate"),
          prop: "licensePlate",
          width: this.$t("carManagement.tableWidth.licensePlate"),
          checked: true
        },
        {
          label: this.$t('carManagement.regVin'),
          prop: 'vinNo',
          checked: true
        },
        {
          label: this.$t('carManagement.ecuVin'),
          prop: 'ecuVin',
          checked: true
        },
        {
          label: this.$t('public.obdCode'),
          prop: "barCode",
          checked: true
        },
        {
          label: this.$t("carManagement.brand"),
          prop: "brandName",
          checked: true
        },
        {
          label: this.$t("carManagement.series"),
          prop: "seriesName",
          checked: false
        },
        {
          label: this.$t("carManagement.model"),
          prop: "modelName",
          checked: false
        },
        {
          label: this.$t("carManagement.fuelType"),
          prop: "fuelType",
          checked: true
        },
        {
          label: this.$t('public.sim'),
          prop: "sim",
          checked: true
        },
        {
          label: this.$t("carManagement.bindingState"),
          prop: "carTerminalStatus",
          checked: false
        },
        {
          label: this.$t('carManagement.belong'),
          prop: 'belong',
          width: '100px',
          checked: true
        },
        {
          label: this.$t('carManagement.authorize'),
          prop: 'authorize',
          width: '150px',
          checked: true
        },
        {
          label: this.$t("carManagement.createTime"),
          prop: "createdOn",
          checked: false
        }
      ],
      total: 0,
      totalBinding: 0,
      list: [],
      isEdit: false,
      addUpdateVisible: false,
      listLoading: false,
      // lookHistoryVisible: false,
      lookCarDialogVisible: false,
      terminalVisbles: false,
      importConfig: {
        visible: false,
        url: importVehicleUrl,
        template: '/file/upload/template/CompanyVehicleImportTemplate.xlsx',
        text: this.$t('public.licensePlate'),
        resultVisible: false
      },
      showBingCar: false,
      currentRow: null,
      oid: null,
      belongList: ['personal', 'company', 'subCompany', 'department'],
      userNameList: ['roles'],
      // isShow:false  //表格多选框是否显示
    }
  },
  computed: {
    areas() {
      return this.$store.state.cache.areas
    },
    models() {
      return this.$store.getters.cascaderModels
    },
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    },
    language() {
      return this.$store.getters.language
    },
    belongIndex() {
      const reg400 = /^([400, 410]|[4]\d{2})$/
      const reg500 = /^([500, 510]|[5]\d{2})$/
      const reg600 = /^([600, 610]|[6]\d{2})$/
      const w = this.$store.state.user.roles[0].weight
      let result = [
        reg400.test(w),
        reg500.test(w),
        reg600.test(w)
      ]
      return result.findIndex(v => v === true) + 1
    },
    totalUnbinding() {
      return this.total - this.totalBinding
    },
    displayName() {
      let roles = []
      let isShow = false
      this.userNameList.forEach((v) => {
        if (this.$store.state.user.userInfo[v]) {
          roles = this.$store.state.user.userInfo[v]
          roles.forEach((role) =>{
              if(role.weight==400 || role.weight==410 || role.weight==500 || role.weight==510 ||role.weight==600 ||role.weight==610){
                  isShow=true
              }
          })
        }
      })
      return isShow
    }
  },
  created() {
    getCommandParam().then(({ data }) => {
      if (data.code === 0) {
        this.oid = data.data[4].oid
      }
    })
  },
  methods: {
    handleExport() {
      this.$http.post(exportVehicleUrl, this.listQuery, {
        responseType: 'arraybuffer'
      })
    },
    handleExportBI() {
      this.$http.post(exportToyotaBuyInUrl, this.listQuery, {
        responseType: 'arraybuffer'
      })
    },
    handleExportSO() {
      this.$http.post(exportToyotaSellOutUrl, this.listQuery, {
        responseType: 'arraybuffer'
      })
    },
    handleImport() {
      this.importConfig.visible = true
      this.importConfig.url = importVehicleUrl
      this.importConfig.template = '/file/upload/template/CompanyVehicleImportTemplate.xlsx'
    },
    handleImportBI() {
      this.importConfig.visible = true
      this.importConfig.url = importToyotaBuyInUrl
      this.importConfig.template = '/file/upload/template/importBuyInCar.xlsx'
    },
    handleImportSO() {
      this.importConfig.visible = true
      this.importConfig.url = importToyotaSellOutUrl
      this.importConfig.template = '/file/upload/template/importSellOutCar.xlsx'
    },
    // 加载数据
    listLoad() {
      this.listLoading = true
      // eslint-disable-next-line no-unused-vars
      const { carSettings, ...postData } = this.listQuery
      this.$http.post(vehicleListUrl, postData).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
          this.totalBinding = data.totalBinding
          let orderSort = "licensePlate,areaName,brandName,seriesName,modelName,fuelType,carTerminalStatus"
          this.setOrderField(orderSort, this.tableList)
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    /**
     * 检测是否未选择
     */
    checkCurrentRowEmpty() {
      return !this.currentRow
    },
    handleCurrentRowChange(val) {
      this.currentRow = val
    },
    // 解绑OBD
    handleUntyOBD(row) {
      if (row.barCode !== "") {
        const postData = {}
        const { carId } = row
        this.$prompt(this.$t('carManagement.noComments'), this.$t('carManagement.tips'), {
          confirmButtonText: this.$t('public.define'),
          cancelButtonText: this.$t('public.cancel'),
          // inputPattern: /\+/,
          inputErrorMessage: this.$t('carManagement.errorComments'),
          inputValidator(v) {
            if (v && v.length > 250) return false
            return true
          }
        }).then(({ value }) => {
          postData.remark = value
          untyOBD(carId, postData).then(({ data }) => {
            if (data.code === 0) {
              this.$message.success({
                message: this.$t("carManagement.untysuccess"),
                duration: 2 * 1000
              })
              this.listLoad()
            }
          })
        }).catch(() => { })

      } else {
        this.$alert(this.$t("carManagement.notOBD"), this.$t("public.tips"), {
          confirmButtonText: this.$t("public.define")
        })
      }
    },

    // 查看绑定历史
    handleHistory() {
      if (this.checkCurrentRowEmpty()) {
        this.$alert(this.$t("public.viewTips"), this.$t("public.tips"), {
          confirmButtonText: this.$t("public.define")
        })
        return
      }
      this.lookHistoryVisible = true
    },
    handleChange(val) {
      let arr = ["brand", "series", "model"]
      arr.forEach(item => {
        this.listQuery[item] = ""
      })
      for (let i = 0; i < arr.length; i++) {
        this.listQuery[arr[i]] = val[i]
      }
      this.$refs.cascader.panel.menus = [
        this.$refs.cascader.panel.store.getNodes()
      ]
      this.$refs.cascader.dropDownVisible = false
    },
    handleBind(row) {
      // 根据carTerminalStatus来判断
      // eslint-disable-next-line no-unused-vars
      const { carTerminalStatus } = row
      if (carTerminalStatus === 1) {
        this.handleUntyOBD(row)
      } else {
        // this.terminalVisbles = true;
        this.showBingCar = true
        // this.selectTerminal(row)
      }
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 新增成功
    addComplete() {
      this.listLoad()
    },
    // 编辑
    handleUpdate() {
      if (this.checkCurrentRowEmpty()) {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
      } else if (this.belongIndex !== this.currentRow.belong) {
        this.$message.warning(this.$t('carManagement.message.noPermission'))
      } else {
        this.isEdit = true
        this.addUpdateVisible = true
      }
    },
    // 编辑成功
    updateComplete() {
      this.listLoad()
    },
    //禁用部分无权限的勾选框
    checkboxT(row){
      if(this.belongIndex !== row.belong){
        return false
      }else {
        return true
      }
    },
    handleDelete() {
      let selection=this.$refs.multipleTable.selection
      if(selection.length!==0){
        //有多选框勾选
          let carIds = selection.map((s)=>{
              return s.carId
            })
          this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define'),
          cancelButtonText: this.$t('public.cancel'),
          type: 'warning'
          }).then(()=>{
              //批量删除
            this.$http.post(deleteVehicleListUrl, carIds).then(({data})=>{
              if (data.code == 0) {
                this.listLoad()
                this.$message.success({
                  message: this.$t('public.deleteSuccess'),
                  duration: 2 * 1000
                })
              }
            })
          })
      }else if(selection.length==0 && this.checkCurrentRowEmpty()){
        //没任何勾选和点击行，提示请选择
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
      }else{
        if(this.checkCurrentRowEmpty()){
          this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
          })
        }else if(this.belongIndex !== this.currentRow.belong){
          this.$message.warning(this.$t('carManagement.message.noPermission'))
        }else{
          this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define'),
          cancelButtonText: this.$t('public.cancel'),
          type: 'warning'
          })
            .then(() => {
              //常规删除
              this.$http.delete(resolve(deleteVehicleUrl, this.currentRow.carId), ({ data }) => {
                if (data.code == 0) {
                  this.listLoad()
                  this.$message.success({
                    message: this.$t('public.deleteSuccess'),
                    duration: 2 * 1000
                  })
                }
              })
            })

        }
      }
    },
    // 导入成功之后刷新list
    reloadList(data) {
      this.importConfig.result = data
      this.importConfig.resultVisible = true
      this.listLoad()
    },
    // IO开关
    handleSwitch(row, num) {
      this.$confirm(this.$t('carManagement.operate.operateTip'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      }).then(() => {
        const { barCode } = row
        const strcommandparams = []
        let io = [
          num === 1 ? row.io1 === 0 : !(row.io1 === 0),
          num === 2 ? row.io2 === 0 : !(row.io2 === 0),
          false,
          false
        ]
        row.needDisabled = true
        strcommandparams.push({
          param: IOLIST.findIndex(item => JSON.stringify(item) === JSON.stringify(io)),
          commandtype: 0,
          commandid: this.oid
        })
        let postData = {
          caridlist: barCode,
          maxexetimes: 3,
          operationname: `IO#${num}-${io[num - 1] ? 'Open' : 'Close'}-${barCode}-${new Date().getTime()}`,
          strcommandparams: JSON.stringify(strcommandparams)
        }
        createCommond(postData).then(({ data }) => {
          if (data.code === 0) {
            this.$message.success({
              message: this.$t('carManagement.operate.success'),
              duration: 2 * 1000
            })
            row.needDisabled = false
            this.listLoad()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.total-info {
  span {
    margin-left: 15px;
  }
}
.car-management {
  .el-button--primary {
    &.is-disabled {
      background-color: #cccccc;
      border-color: #cccccc;
      color: #aaaaaa !important;
    }
    &.io-pending {
      color: white !important;
    }
  }
}
</style>
